import { MY_ACCOUNT } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_ACCOUNT;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Settings,
    method: 'addApplication',
    menuOrder: 3,
    showInLoginMenu: true,
    showInMemberMenu: true,
    urlOverride: 'my-account',
    social: false,
    uninstallable: true,
    page: {
        name: t('member-pages.my-account.name'),
        shortDescription: t('member-pages.my-account.subtitle'),
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        screenshots: [],
        description: '',
        origin: '',
        isNew: false,
    },
});
//# sourceMappingURL=account.js.map